import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .img-banner {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
`;
